import env from '@repo/env';

import { urlParams } from '../window';

const DEBUG_QUERY_PARAM = '__debug';
const DEBUG_ANALYTICS_QUERY_PARAM = '__debug_analytics';

export enum ForceEnterDebugReason {
  'UpdateMockupTemplate' = 'UpdateMockupTemplate',
}

/**
 * Sometimes we might want to enter debug mode manually.
 * USE CAREFULLY.
 * @param reason, must be specified and check against the allowed list.
 */
export const forceEnterDebug = (reason?: ForceEnterDebugReason): void => {
  if (!isDebugActive() && window && reason && reason in ForceEnterDebugReason) {
    urlParams.append(DEBUG_QUERY_PARAM, 't');
    window.history.replaceState(null, '', `?${urlParams.toString()}`);
  }
};

let debugEnabledDynamically = false;
export const setDebugEnabled = (enabled: boolean): void => {
  debugEnabledDynamically = enabled;
};

export const isDebugEnabledDynamically = (): boolean => {
  return debugEnabledDynamically && !isDebugQueryParamPresent();
};

const isDebugQueryParamPresent = (): boolean => {
  return Boolean(urlParams.get(DEBUG_QUERY_PARAM));
};
export const isDebugActive = (): boolean => {
  if (typeof window !== 'undefined' && 'Cypress' in window) {
    return false;
  }

  if (env.nodeEnv === 'test') {
    return false;
  }

  return debugEnabledDynamically || isDebugQueryParamPresent();
};

export const isDebugAnalyticsActive = (): boolean => {
  return Boolean(urlParams.get(DEBUG_ANALYTICS_QUERY_PARAM));
};
